import Microgame from '../engine/Microgame.js';

export default class PokeGame extends Microgame {

    static getPlayback() {
        return {
            title: { fr: `Secoue-le !`, en: `Poke!`, es: `¡Despierta!` },
            controls: { fr: `Appuie de manière répétée pour l'embêter`, en: `Tap repeatedly to annoy it`, es: `Toca repetidamente para molestarlo` },
            objective: { fr: `Appuie assez de fois pour réveiller la chose`, en: `Tap enough times to wake the thing up`, es: `Toca suficientes veces para despertar a la cosa` },
            icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="var(--primary-color)" stroke-width="2"><path d="m20.2 7.8-8.5 8.5L7.5 12"/><path d="m3 14 3-3"/><path d="m14 3-3 3"/><path d="M22 22 20.2 20.2"/></svg>`,
            actions: [
                { type: 'wait', duration: 260 },
                { type: 'tap', x: 50, y: 50, duration: 180 },
                { type: 'wait', duration: 120 },
                { type: 'tap', x: 50, y: 50, duration: 180 },
                { type: 'wait', duration: 120 },
                { type: 'tap', x: 50, y: 50, duration: 180 },
                { type: 'wait', duration: 120 },
                { type: 'tap', x: 50, y: 50, duration: 180 },
                { type: 'wait', duration: 460 },
            ],
            loopDuration: 2800
        };
    }
    constructor(engine) {
        super(engine);
        this.blob = null;
        this.taps = 0;
        
        const speedMult = engine.speedMultiplier || 1.0;
        this.duration = 2600; // 650ms at x4 (engine divides by speedMult)
    }

    setup() {
        this.engine.ui.instruction.textContent = "POKE!";

        // Blob (Primary)
        this.blob = document.createElement('div');
        this.blob.style.position = 'absolute';
        this.blob.style.width = '150px';
        this.blob.style.height = '150px';
        this.blob.style.background = this.primaryColor;
        this.blob.style.top = '50%';
        this.blob.style.left = '50%';
        this.blob.style.transform = 'translate(-50%, -50%)';
        this.blob.style.borderRadius = '50%';
        this.blob.style.boxShadow = `0 0 30px ${this.primaryColor}`;
        this.blob.style.cursor = 'pointer';
        this.blob.style.transition = 'transform 0.1s, background 0.1s';
        this.container.appendChild(this.blob);

        // Eyes
        const leftEye = document.createElement('div');
        leftEye.style.position = 'absolute';
        leftEye.style.width = '20px';
        leftEye.style.height = '20px';
        leftEye.style.background = '#000';
        leftEye.style.borderRadius = '50%';
        leftEye.style.top = '40px';
        leftEye.style.left = '40px';
        this.blob.appendChild(leftEye);

        const rightEye = document.createElement('div');
        rightEye.style.position = 'absolute';
        rightEye.style.width = '20px';
        rightEye.style.height = '20px';
        rightEye.style.background = '#000';
        rightEye.style.borderRadius = '50%';
        rightEye.style.top = '40px';
        rightEye.style.right = '40px';
        this.blob.appendChild(rightEye);

        // Mouth
        const mouth = document.createElement('div');
        mouth.style.position = 'absolute';
        mouth.style.width = '40px';
        mouth.style.height = '10px';
        mouth.style.background = '#000';
        mouth.style.borderRadius = '10px';
        mouth.style.bottom = '40px';
        mouth.style.left = '50%';
        mouth.style.transform = 'translateX(-50%)';
        this.blob.appendChild(mouth);

        // Idle Animation
        this.blob.animate([
            { transform: 'translate(-50%, -50%) scale(1, 1)' },
            { transform: 'translate(-50%, -50%) scale(1.05, 0.95)' },
            { transform: 'translate(-50%, -50%) scale(1, 1)' }
        ], {
            duration: 1000,
            iterations: Infinity
        });

        this.onTap = this.onTap.bind(this);
        this.blob.addEventListener('pointerdown', this.onTap);
    }

    onTap() {
        if (this.won) return;

        this.taps++;

        if (this.taps < 4) {
            // Swell and redden
            const scale = 1 + (this.taps * 0.2);
            this.blob.style.transform = `translate(-50%, -50%) scale(${scale})`;

            // Shake
            this.blob.animate([
                { transform: `translate(-50%, -50%) scale(${scale}) rotate(0deg)` },
                { transform: `translate(-50%, -50%) scale(${scale}) rotate(-10deg)` },
                { transform: `translate(-50%, -50%) scale(${scale}) rotate(10deg)` },
                { transform: `translate(-50%, -50%) scale(${scale}) rotate(0deg)` }
            ], {
                duration: 200
            });

        } else {
            // Explode
            this.win();
            this.blob.style.display = 'none'; // Hide blob
            this.createExplosion();
        }
    }

    createExplosion() {
        // Particles
        for (let i = 0; i < 20; i++) {
            const p = document.createElement('div');
            p.style.position = 'absolute';
            p.style.width = '15px';
            p.style.height = '15px';
            p.style.background = this.primaryColor;
            p.style.left = '50%';
            p.style.top = '50%';
            p.style.borderRadius = '50%';
            this.container.appendChild(p);

            const angle = Math.random() * Math.PI * 2;
            const dist = 150 + Math.random() * 100;

            p.animate([
                { transform: 'translate(-50%, -50%) scale(1)', opacity: 1 },
                { transform: `translate(calc(-50% + ${Math.cos(angle) * dist}px), calc(-50% + ${Math.sin(angle) * dist}px)) scale(0)`, opacity: 0 }
            ], {
                duration: 600,
                easing: 'ease-out'
            });
        }
    }

    cleanup() {
        super.cleanup();
        if (this.blob) this.blob.removeEventListener('pointerdown', this.onTap);
    }
}
